/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FineThresholdSettings = {
    ownerId: string;
    ownerType: FineThresholdSettings.ownerType;
    fineAmount: number;
    overdueDays: number;
    deviceType: FineThresholdSettings.deviceType;
    type: FineThresholdSettings.type;
    createdByUserId?: string;
    id?: string;
    createdAt?: string;
    updatedAt?: string;
};
export namespace FineThresholdSettings {
    export enum ownerType {
        SHOP = 'SHOP',
        FINANCIER = 'FINANCIER',
    }
    export enum deviceType {
        IOS = 'IOS',
        ANDROID = 'ANDROID',
    }
    export enum type {
        PER_DIEM = 'PER_DIEM',
        FLAT_RATE = 'FLAT_RATE',
    }
}

